import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import {
  TuiButtonModule,
  TuiIconsModule,
  TuiNavigationModule,
} from '@taiga-ui/experimental';
import { InvoicesRouteNames } from '../../../../route-names';

@Component({
  selector: 'app-journal-page',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLinkActive,
    TuiButtonModule,
    TuiIconsModule,
    TuiNavigationModule,
    RouterLink,
  ],
  templateUrl: './journal-page.component.html',
  styleUrl: './journal-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JournalPageComponent {
  readonly pages = [
    {
      name: 'Спецификации',
      id: InvoicesRouteNames.SPECIFICATION,
    },
    {
      name: 'Инвойсы',
      id: InvoicesRouteNames.PARSED_INVOICE,
    },
    {
      name: 'Инвойсы (бухгалтерия)',
      id: InvoicesRouteNames.ACCOUNTING_INVOICE,
    },
  ];
}
